import processTvChartDividends from "./processTvChartDividends";

/**
 * Build markers map for MARKERS_UPDATE from withChartData props.
 */
export default function buildTvChartBridgeMarkersPayload({
  dividends,
  reportDates,
  mediaMonitorMessages,
  lastMinMaxPoints,
  insiderTransactions
} = {}) {
  const current =
    lastMinMaxPoints?.current ||
    (Array.isArray(lastMinMaxPoints) ? [] : lastMinMaxPoints?.current) ||
    [];
  const previous =
    lastMinMaxPoints?.previous ||
    (Array.isArray(lastMinMaxPoints) ? [] : lastMinMaxPoints?.previous) ||
    [];

  return {
    dividends: processTvChartDividends(dividends),
    financialReports: reportDates || [],
    mediaMonitorMessages: mediaMonitorMessages || [],
    currentLastMinMaxPoints: current || [],
    previousLastMinMaxPoints: previous || [],
    insiderTransactions: insiderTransactions || []
  };
}
